import { connect } from "react-redux";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withHandlers from "recompose/withHandlers";
import withState from "recompose/withState";

import product from "src/common/config/product";
import { getPrismicProductByLocale } from "src/client/js/store/selectors/prismic/product";
import withMedia from "src/client/js/view/hocs/withMediaQueries";
import withProductCustomisation from "src/client/js/view/hocs/withProductCustomisation";
import { withModel } from "../../data-providers/model";

import { getCompletedDrawer } from "../CanvasDrawers/duck";
import {
  isLoading,
  getPages,
  buildPreviewPages,
  getNavItems,
  updateBookPreviewPages,
  setIsBookPreviewHeidelberg,
  isHeidelberg,
  setBookPreviewActivePage,
  getActivePage,
  setBookPreviewImageWidth,
  getImageWidth,
  getScrollAmount,
  setBookPreviewScroll,
  getBookPreviewUrlsFailure,
} from "./duck";
import BookPreview from "./BookPreview";
import { parseQuery, hasInsideCovers, getBreadCrumbType } from "./helpers";

const enhance = compose(
  withProductCustomisation,
  withModel,
  connect(
    (state, props) => ({
      isLoading: isLoading(state),
      pages: getPages(state),
      navItems: getNavItems(state),
      isHeidelberg: isHeidelberg(state),
      activePage: getActivePage(state),
      imageWidth: getImageWidth(state),
      scrollPosition: getScrollAmount(state),
      prismicProduct: getPrismicProductByLocale(
        state,
        props.productId,
        props.productCustomisation.locale
      ),
      completedDrawer: getCompletedDrawer(state),
    }),
    (dispatch) => ({
      setScrollPosition: (scrollAmount) =>
        dispatch(setBookPreviewScroll(scrollAmount)),
      buildPreviewPages: (options) => dispatch(buildPreviewPages(options)),
      sendPreviewFailure: (error) => dispatch(getBookPreviewUrlsFailure(error)),
      updateBookPreviewPages: (pages) =>
        dispatch(updateBookPreviewPages(pages)),
      setIsHeidelberg: (isHeidelberg) =>
        dispatch(setIsBookPreviewHeidelberg(isHeidelberg)),
      setActivePage: (activePage) =>
        dispatch(setBookPreviewActivePage(activePage)),
      setBookPreviewImageWidth: (imageWidth) =>
        dispatch(setBookPreviewImageWidth(imageWidth)),
    })
  ),
  withProps((props) => {
    // Check if product in config otherwise fall back to eagle
    // TODO update all eagle config so dimensions come form there or muse
    const currentProduct =
      product.getProductBySku(props.productId) || props.model.eagleProduct;
    const width = currentProduct.dimensions.width;
    const height = currentProduct.dimensions.height;
    const ratio = height / width;

    let multiplier = 50;
    if (ratio === 1) {
      multiplier = 40;
    } else if (ratio > 1) {
      multiplier = 35;
    }
    return {
      padding: props.isHeidelberg ? ratio * multiplier : 0,
      query: parseQuery(props.location.search),
      multiplier,
      hasInsideCovers: hasInsideCovers(props.productId),
      hasCharacterPicker:
        getBreadCrumbType(props.productId) === "character-picker",
      hasBreadCrumb:
        getBreadCrumbType(props.productId, props.breadcrumbs) === "breadcrumb",
      sortBreadcrumbs: props.sortBreadcrumbs === "true",
    };
  }),
  withHandlers((props) => ({
    calculatePreviewImageWidth: (props) => () => {
      props.setBookPreviewImageWidth(window.innerWidth * 0.75);
    },
  })),
  withState("transform", "setTransform", null),
  withState("needsTransform", "setNeedsTransform", false),
  withMedia
);

export default enhance(BookPreview);
